'use client';
import React from 'react';

interface FilterChip {
  label: string;
  value: string;
}

interface FilterRowProps {
  filters: FilterChip[];
  active: string;
  onChange: (value: string) => void;
}

export default function FilterRow({ filters, active, onChange }: FilterRowProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {filters.map((f) => {
        const isActive = active === f.value;
        return (
          <button
            key={f.value}
            onClick={() => onChange(f.value)}
            className={`px-3.5 py-1.5 rounded-full text-[13px] font-medium transition-all duration-150 filter-chip ${isActive ? 'filter-chip-active' : ''}`}
            style={
              isActive
                ? {
                    background: 'rgba(76,201,255,0.15)',
                    border: '1px solid rgba(76,201,255,0.35)',
                    color: '#4CC9FF',
                  }
                : {
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.10)',
                    color: '#A7A3C4',
                  }
            }
          >
            {f.label}
          </button>
        );
      })}
    </div>
  );
}
